const hexToRgb = hex => {
  if (!hex || !hex.startsWith('#')) return hex
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  const fullHex = hex.replace(
    shorthandRegex,
    (m, r, g, b) => r + r + g + g + b + b
  )
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex)
  return result
    ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`
    : hex
}

const rgbToHex = rgbStr => {
  if (!rgbStr || rgbStr.startsWith('#')) return rgbStr.toUpperCase()
  const rgbMatch = rgbStr.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i)
  if (!rgbMatch) return rgbStr.toUpperCase()
  return (
    '#' +
    rgbMatch
      .slice(1, 4)
      .map(x => parseInt(x).toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
  )
}

export const colorOptions = [
  { value: '#FCE4EC', border: '#D81B60', textColor: '#D81B60' },
  { value: '#E6B0AA', border: '#78281F', textColor: '#78281F' },
  { value: '#FAE5D3', border: '#D35400', textColor: '#D35400' },
  { value: '#F0F4C3', border: '#827717', textColor: '#827717' },
  { value: '#A9DFBF', border: '#196F3D', textColor: '#196F3D' },
  { value: '#D0ECE7', border: '#0B5345', textColor: '#0B5345' },
  { value: '#E3F2FD', border: '#1565C0', textColor: '#1565C0' },
  { value: '#7FB3D5', border: '#154360', textColor: '#154360' },
  { value: '#E8DAEF', border: '#76448A', textColor: '#76448A' },
  { value: '#E59866', border: '#6E2C00', textColor: '#6E2C00' },
  { value: '#D7CCC8', border: '#3E2723', textColor: '#3E2723' },
  { value: '#F8ACC9', border: '#C2185B', textColor: '#C2185B' },
  { value: '#FAD199', border: '#CC5E00', textColor: '#CC5E00' },
  { value: '#F7DC6F', border: '#7D6608', textColor: '#7D6608' },
  { value: '#A2D5F2', border: '#0D47A1', textColor: '#0D47A1' },
  { value: '#A9C2F0', border: '#1A237E', textColor: '#1A237E' },
  { value: '#C7B4F7', border: '#4A148C', textColor: '#4A148C' },
  { value: '#D4AC0D', border: '#6E2C00', textColor: '#6E2C00' },
  { value: '#BDC3C7', border: '#2C3E50', textColor: '#2C3E50' },
  { value: '#00FF00', border: '#034303', textColor: '#034303' },
  { value: '#FFFF00', border: '#565600', textColor: '#565600' },
  { value: '#ED1C24', border: '#c5151b', textColor: '#FFFFFF' },
  { value: '#2452A0', border: '#1d468d', textColor: '#FFFFFF' },
  { value: '#FF7F00', border: '#a85604', textColor: '#ffffff' },
  { value: '#00A859', border: '#04743f', textColor: '#FFFFFF' },
  { value: '#662D91', border: '#3f195c', textColor: '#FFFFFF' },
  { value: '#FFC107', border: '#a97f00', textColor: '#ffffff' },
  { value: '#FF5722', border: '#c02d00', textColor: '#FFFFFF' },
  { value: '#2E7D32', border: '#1d6520', textColor: '#FFFFFF' },
  { value: '#4527A0', border: '#2c1476', textColor: '#FFFFFF' }
]

export function getColorConfig(color) {
  if (!color)
    return { value: '#FCE4EC', border: '#D81B60', textColor: '#D81B60' }

  const searchHex = rgbToHex(color)
  const colorObj = colorOptions.find(
    option => option.value.toUpperCase() === searchHex
  )

  return (
    colorObj || { value: '#FCE4EC', border: '#D81B60', textColor: '#D81B60' }
  )
}

export function getTextColor(color) {
  if (!color) return '#FFFFFF'

  const searchHex = rgbToHex(color)
  const colorObj = colorOptions.find(
    option => option.value.toUpperCase() === searchHex
  )

  return colorObj?.textColor || '#FFFFFF'
}

export { hexToRgb, rgbToHex }
